import * as d3 from 'd3';

// Theme-driven port of the old drawUtils/currentPriceLabel.js -- a dashed
// reference line + pill label pinned to the right axis at the latest close.
export function drawCurrentPriceLabel({ group, yScale, availableWidth, latest, prev, theme }) {
  group.selectAll('*').remove();
  if (!latest) return;

  const price = latest.close;
  const prevPrice = prev ? prev.close : price;
  const color = price >= prevPrice ? theme.bull.strong : theme.bear.strong;
  const y = yScale(price);

  group
    .append('line')
    .attr('x1', 0)
    .attr('y1', y)
    .attr('x2', availableWidth)
    .attr('y2', y)
    .attr('stroke', color)
    .attr('stroke-width', 1)
    .attr('stroke-dasharray', '3,3')
    .attr('opacity', 0.55);

  const labelWidth = 60;
  const labelHeight = 22;

  group
    .append('rect')
    .attr('x', availableWidth + 2)
    .attr('y', y - labelHeight / 2)
    .attr('width', labelWidth)
    .attr('height', labelHeight)
    .attr('rx', 4)
    .attr('fill', color);

  group
    .append('text')
    .attr('x', availableWidth + 2 + labelWidth / 2)
    .attr('y', y)
    .attr('dominant-baseline', 'middle')
    .attr('text-anchor', 'middle')
    .attr('font-size', 11.5)
    .attr('font-family', theme.typography.fontFamily)
    .attr('font-weight', 700)
    .attr('fill', theme.background.chart)
    .style('font-variant-numeric', 'tabular-nums')
    .text(d3.format('$,.2f')(price));
}
